import React from 'react';

// local dependencies
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { layoutConfig } from 'config/table-configs/mail-prescriptions';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsSavingsRetailPrescriptionWidgetSuccess as MemberDetailsSavingsRetailPrescriptionWidgetSuccess } from 'ui/views/widgets/memberDetailsSavingsRetailPrescriptionWidget';
 *
 * // render
 * <MemberDetailsSavingsRetailPrescriptionWidgetSuccess propName='propValue'/>
 */
const memberDetailsSavingsRetailPrescriptionWidgetSuccess = ( props ) => {

    return (
        <div className='ui-member-details-savings-retail-prescriptions-widget'>
            <TableSearchWidget
                layoutConfig = { layoutConfig }
                templateType = 'inline'
                tableResponse = { props.componentData }
                requestPayload={ props.requestPayload }
                onActionClick={ props.onActionClick }
                classNameTable={ 'ui-member-details-savings-mail-prescriptions-widget__table'}
            />
        </div>
    );
};

// set display name
memberDetailsSavingsRetailPrescriptionWidgetSuccess.displayName = 'memberDetailsSavingsRetailPrescriptionWidget';

// set default props
memberDetailsSavingsRetailPrescriptionWidgetSuccess.defaultProps = {
    requestPayload: {},
};

// prop types
memberDetailsSavingsRetailPrescriptionWidgetSuccess.propTypes = {};

// ***********************************************

/**
 * @type {object}
 * @desc A React presentation/dumb view component preloader.
 * @example
 * import { memberDetailsSavingsMailPrescriptionWidgetPreloader as MemberDetailsSavingsMailPrescriptionWidgetPreloader } from 'ui/views/widgets/memberDetailsSavingsMailPrescriptionWidget';
 *
 * // render
 * <memberDetailsSavingsMailPrescriptionWidgetPreloader propName='propValue'/>
 */
const memberDetailsSavingsRetailPrescriptionWidgetPreloader = ( ) => {
    return (
        <div className='ui-member-details-savings-retail-prescription-widget-preloader'>
            <TableSearchInlineWidgetPreloader
                className='ui-member-details-savings-retail-prescription-widget-preloader__table-preloader'
            />
        </div>
    );
};

// set display name
memberDetailsSavingsRetailPrescriptionWidgetPreloader.displayName = 'memberDetailsSavingsRetailPrescriptionWidgetPreloader';

// set default props
memberDetailsSavingsRetailPrescriptionWidgetPreloader.defaultProps = {};

// prop types
memberDetailsSavingsRetailPrescriptionWidgetPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsSavingsRetailPrescriptionWidget as MemberDetailsSavingsRetailPrescriptionWidget } from 'ui/views/widgets/memberDetailsSavingsRetailPrescriptionWidget';
 *
 * // render
 * <memberDetailsSavingsRetailPrescriptionWidget propName='propValue'/>
 */
export const memberDetailsSavingsRetailPrescriptionWidget = withNetworkState( memberDetailsSavingsRetailPrescriptionWidgetPreloader, memberDetailsSavingsRetailPrescriptionWidgetSuccess );

